import CornerRadius from './corner-radius.svg';
import EditImage from './edit-image-lg.svg';
import Eraser from './eraser.svg';
import MagicWand from './magic-wand.svg';

export default {
  CornerRadius,
  EditImage,
  Eraser,
  MagicWand,
};
